"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.redirectToAgent = exports.getDefaultPrompt = exports.validateOnSave = exports.saveEnvVariablesForActions = exports.isNotAValidUrl = void 0;
var History_1 = __importDefault(require("@src/History"));
var api_1 = require("../CodeNode/store/api");
exports.isNotAValidUrl = function (url) {
    var pattern = new RegExp('^https?:\\/\\/');
    return !pattern.test(url);
};
function saveEnvVariablesForActions(domainId, envVariables, cb) {
    var _this = this;
    if (cb === void 0) { cb = function (msg) { }; }
    var data = {
        env_variables: envVariables,
    };
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var envResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api_1.saveEnvVariables(domainId, data)];
                case 1:
                    envResponse = _a.sent();
                    resolve(envResponse);
                    cb();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    cb('Error! There was a problem in completing your request');
                    reject(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.saveEnvVariablesForActions = saveEnvVariablesForActions;
exports.validateOnSave = function (actionData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
    var actionName = actionData.name;
    var actionType = actionData.action_type;
    var actionDescription = (_b = (_a = actionData.function_details) === null || _a === void 0 ? void 0 : _a.function_description) !== null && _b !== void 0 ? _b : '';
    var functionName = (_c = actionData.function_name) !== null && _c !== void 0 ? _c : '';
    var functionParameterList = (_e = (_d = actionData.function_details) === null || _d === void 0 ? void 0 : _d.function_params) !== null && _e !== void 0 ? _e : [];
    var integrationType = actionData.action_type;
    var webSearchPrompt = (_h = (_g = (_f = actionData.action_details) === null || _f === void 0 ? void 0 : _f['1']) === null || _g === void 0 ? void 0 : _g.prompt) !== null && _h !== void 0 ? _h : '';
    var webSearchContextKeywords = (_l = (_k = (_j = actionData.action_details) === null || _j === void 0 ? void 0 : _j['1']) === null || _k === void 0 ? void 0 : _k.enforce_keywords) !== null && _l !== void 0 ? _l : '';
    var ragPrompt = (_p = (_o = (_m = actionData.action_details) === null || _m === void 0 ? void 0 : _m['2']) === null || _o === void 0 ? void 0 : _o.prompt) !== null && _p !== void 0 ? _p : '';
    var appId = (_s = (_r = (_q = actionData.action_details) === null || _q === void 0 ? void 0 : _q['2']) === null || _r === void 0 ? void 0 : _r.app_id) !== null && _s !== void 0 ? _s : '';
    var locationId = (_v = (_u = (_t = actionData.action_details) === null || _t === void 0 ? void 0 : _t['2']) === null || _u === void 0 ? void 0 : _u.location_id) !== null && _v !== void 0 ? _v : '';
    var promptAsAnActionPrompt = (_y = (_x = (_w = actionData.action_details) === null || _w === void 0 ? void 0 : _w['3']) === null || _x === void 0 ? void 0 : _x.prompt) !== null && _y !== void 0 ? _y : '';
    var indexName = (_0 = (_z = actionData.function_details) === null || _z === void 0 ? void 0 : _z.index_name) !== null && _0 !== void 0 ? _0 : '';
    var displayPreferenceTitle = (_3 = (_2 = (_1 = actionData.function_details) === null || _1 === void 0 ? void 0 : _1.display_preference) === null || _2 === void 0 ? void 0 : _2.title) !== null && _3 !== void 0 ? _3 : '';
    var displayPreferenceSubtitle = (_6 = (_5 = (_4 = actionData.function_details) === null || _4 === void 0 ? void 0 : _4.display_preference) === null || _5 === void 0 ? void 0 : _5.sub_title) !== null && _6 !== void 0 ? _6 : '';
    var displayPreferenceImageLink = (_9 = (_8 = (_7 = actionData.function_details) === null || _7 === void 0 ? void 0 : _7.display_preference) === null || _8 === void 0 ? void 0 : _8.image_link) !== null && _9 !== void 0 ? _9 : '';
    var displayPreferenceProductLink = (_12 = (_11 = (_10 = actionData.function_details) === null || _10 === void 0 ? void 0 : _10.display_preference) === null || _11 === void 0 ? void 0 : _11.product_link) !== null && _12 !== void 0 ? _12 : '';
    var numberOfDisplayedProducts = (_14 = (_13 = actionData.function_details) === null || _13 === void 0 ? void 0 : _13.hits_per_page) !== null && _14 !== void 0 ? _14 : '';
    var enableProductFollowUpMsgs = (_17 = (_16 = (_15 = actionData.action_details) === null || _15 === void 0 ? void 0 : _15['4']) === null || _16 === void 0 ? void 0 : _16.enable_prod_follow_up_msgs) !== null && _17 !== void 0 ? _17 : true;
    var productFollowUpParams = (_20 = (_19 = (_18 = actionData.action_details) === null || _18 === void 0 ? void 0 : _18['4']) === null || _19 === void 0 ? void 0 : _19.aisa_follow_msg_params) !== null && _20 !== void 0 ? _20 : [];
    var functionNameRegex = /^(?=.*[a-zA-Z0-9])[\w]*$/;
    var actionNameRegex = /^(?=.*[a-zA-Z0-9])[ \w]*$/;
    var ragRegex = /^[a-zA-Z0-9_-]+$/;
    var isError = false;
    var actionErrors = {};
    if (!(functionName === null || functionName === void 0 ? void 0 : functionName.trim())) {
        isError = true;
        actionErrors['functionNameError'] =
            "Please enter a function name. It can't be left blank.";
    }
    else if (!functionNameRegex.test(functionName.trim())) {
        isError = true;
        actionErrors['functionNameError'] =
            'Function names can only include letters, numbers, and underscores.';
    }
    else if (functionName.trim().length > 64) {
        isError = true;
        actionErrors['functionNameError'] =
            'Function names must be 64 characters or fewer.';
    }
    else if (((_21 = functionName.trim()) === null || _21 === void 0 ? void 0 : _21.toLowerCase()) === 'break') {
        isError = true;
        actionErrors['functionNameError'] =
            "'break' keyword can not be used as a function name.";
    }
    if (!(actionName === null || actionName === void 0 ? void 0 : actionName.trim())) {
        isError = true;
        actionErrors['actionNameError'] =
            "Please enter the action name. It can't be left blank.";
    }
    else if (!actionNameRegex.test(actionName.trim())) {
        isError = true;
        actionErrors['actionNameError'] =
            'Action name can only include letters, numbers, underscores and spaces.';
    }
    else if (((_22 = actionName.trim()) === null || _22 === void 0 ? void 0 : _22.toLowerCase()) === 'break') {
        isError = true;
        actionErrors['actionNameError'] =
            "'break' keyword can not be used in action name.";
    }
    if (!(actionDescription === null || actionDescription === void 0 ? void 0 : actionDescription.trim())) {
        isError = true;
        actionErrors['actionDescriptionError'] =
            "Please enter the description for the action. It can't be left blank.";
    }
    if (actionDescription.length > 1024) {
        isError = true;
        actionErrors['actionDescriptionError'] =
            'Action description must be of length 1024 characters or less.';
    }
    if (integrationType === 1 && !(webSearchPrompt === null || webSearchPrompt === void 0 ? void 0 : webSearchPrompt.trim())) {
        isError = true;
        actionErrors['webSearchPromptError'] =
            "Please enter the prompt. It can't be left blank.";
    }
    else if (integrationType === 1 && webSearchPrompt.trim().length > 100000) {
        isError = true;
        actionErrors['webSearchPromptError'] =
            'Prompt for web search must be of length 100000 characters or less.';
    }
    else if (integrationType === 1 && !webSearchPrompt.includes('[BREAK]')) {
        isError = true;
        actionErrors['webSearchPromptError'] =
            'Prompt for web search must have [BREAK] condition.';
    }
    else if (integrationType === 1 &&
        (webSearchContextKeywords === null || webSearchContextKeywords === void 0 ? void 0 : webSearchContextKeywords.split(' ').length) > 30) {
        isError = true;
        actionErrors['webSearchContextKeywordError'] =
            'WebSearch Context Keywords must be limited to a maximum of 30 words.';
    }
    if (integrationType === 2) {
        if (!(ragPrompt === null || ragPrompt === void 0 ? void 0 : ragPrompt.trim())) {
            isError = true;
            actionErrors['ragPromptError'] =
                "Please enter the prompt. It can't be left blank.";
        }
        else if (ragPrompt.trim().length > 5000) {
            isError = true;
            actionErrors['ragPromptError'] =
                'Prompt for RAG must be of length 5000 characters or less.';
        }
        if (!(locationId === null || locationId === void 0 ? void 0 : locationId.trim())) {
            isError = true;
            actionErrors['locationIdError'] =
                "Please enter the Location ID. It can't be left blank.";
        }
        else if (!ragRegex.test(locationId.trim())) {
            isError = true;
            actionErrors['locationIdError'] =
                'Location ID can only include letters, numbers, underscores and dashes.';
        }
        if (!(appId === null || appId === void 0 ? void 0 : appId.trim())) {
            isError = true;
            actionErrors['appIdError'] =
                "Please enter the App ID. It can't be left blank.";
        }
        else if (!ragRegex.test(appId.trim())) {
            isError = true;
            actionErrors['appIdError'] =
                'App ID can only include letters, numbers, underscores and dashes.';
        }
    }
    if (integrationType === 3) {
        if (!(promptAsAnActionPrompt === null || promptAsAnActionPrompt === void 0 ? void 0 : promptAsAnActionPrompt.trim())) {
            isError = true;
            actionErrors['promptActionError'] =
                "Please enter the prompt. It can't be left blank.";
        }
        else if (promptAsAnActionPrompt.trim().length > 140000) {
            isError = true;
            actionErrors['promptActionError'] =
                'Prompt must be of length 140000 characters or less.';
        }
        else if (!promptAsAnActionPrompt.includes('[BREAK]')) {
            isError = true;
            actionErrors['promptActionError'] = 'Prompt must have [BREAK] condition.';
        }
    }
    if (integrationType === 4) {
        if (!indexName) {
            isError = true;
            actionErrors['indexNameError'] =
                "Please enter the index name. It can't be left blank.";
        }
        if (!displayPreferenceTitle) {
            isError = true;
            actionErrors['displayPreferenceTitleError'] =
                "Please enter the title. It can't be left blank.";
        }
        if (!displayPreferenceSubtitle) {
            isError = true;
            actionErrors['displayPreferenceSubtitleError'] =
                "Please enter the subtitle. It can't be left blank.";
        }
        if (!displayPreferenceImageLink) {
            isError = true;
            actionErrors['displayPreferenceImageLinkError'] =
                "Please enter the image link. It can't be left blank.";
        }
        if (!displayPreferenceProductLink) {
            isError = true;
            actionErrors['displayPreferenceProductLinkError'] =
                "Please enter the product link. It can't be left blank.";
        }
        if (!numberOfDisplayedProducts) {
            isError = true;
            actionErrors['hitsPerPageError'] =
                'Number of products displayed is required';
        }
        else if (numberOfDisplayedProducts < 5) {
            isError = true;
            actionErrors['hitsPerPageError'] =
                'Number of products displayed must have at least 5 products';
        }
        if (enableProductFollowUpMsgs) {
            if (!productFollowUpParams.length) {
                isError = true;
                actionErrors['productFollowUpParamsError'] =
                    'Follow up Params are mandatory if Product Follow up Messages toggle is on.';
            }
        }
    }
    var actionParametersError = functionParameterList.map(function (_a, index) {
        var _b;
        var mandatory = _a.mandatory, facet = _a.facet, param_name = _a.param_name, param_type = _a.param_type, param_description = _a.param_description, _c = _a.possible_values, possible_values = _c === void 0 ? [] : _c;
        var errorObj = {};
        if (!(param_name === null || param_name === void 0 ? void 0 : param_name.trim())) {
            isError = true;
            errorObj['nameError'] =
                "Pease enter a parameter name. It can't be left blank.";
        }
        if (!functionNameRegex.test(param_name === null || param_name === void 0 ? void 0 : param_name.trim())) {
            isError = true;
            errorObj['nameError'] =
                'Parameter name can only include letters, numbers, and underscores.';
        }
        if (!param_type) {
            isError = true;
            errorObj['typeError'] =
                "Please select the parameter type. It can't be left unselected.";
        }
        if (!(param_description === null || param_description === void 0 ? void 0 : param_description.trim())) {
            isError = true;
            errorObj['descriptionError'] =
                "Please enter a parameter description. It can't be left blank.";
        }
        if (((_b = param_description === null || param_description === void 0 ? void 0 : param_description.trim()) === null || _b === void 0 ? void 0 : _b.split(/\s+/).length) >
            (actionType === 4 ? 1000 : 300)) {
            isError = true;
            errorObj['descriptionError'] = "Parameter Description must be " + (actionType === 4 ? '1000' : '300') + " words or fewer.";
        }
        if ((param_type === null || param_type === void 0 ? void 0 : param_type.trim()) &&
            param_type === 'enum' &&
            !(possible_values === null || possible_values === void 0 ? void 0 : possible_values.length)) {
            isError = true;
            errorObj['possibleValuesError'] =
                'Please enter possible values. This field cannot be left blank.';
        }
        return errorObj;
    });
    return {
        isError: isError,
        actionErrors: actionErrors,
        actionParametersError: actionParametersError,
    };
};
exports.getDefaultPrompt = function (companyName, companyDescription) {
    return "You are a helpful assistant who answers questions about " + (companyName ? companyName : '[Brand Name]') + ".\n\n" + (companyDescription ? companyDescription : '[Brand Description]') + "\n\n## BREAK\nYou should break in the following instances:\n1. If you do not have enough information to answer this query. \n2. If the query is not related to " + (companyName ? companyName : '[Brand Name]') + " at all\n3. If the query is about " + (companyName ? companyName : '[Brand Name]') + "'s competitors \n\nIn this case, respond simply with \"[BREAK]\" and nothing else.";
};
exports.redirectToAgent = function (agentId, domainId) {
    History_1["default"].push("/ai-agents-project/" + domainId + "/agent/" + agentId);
};
